export default __webpack_public_path__ + "static/media/checkout-cart.98d6ca8f.jpeg";